/**
 * Header — sticky top bar primitive used by RootLayout.
 *
 * Brand wordmark on the left, arbitrary chrome (workspace switcher, badge,
 * theme toggle) on the right. Presentational only.
 */

import { Link } from "react-router-dom";
import type { ReactNode } from "react";

import { headerCopy } from "./Header.copy";

export interface HeaderProps {
  readonly right?: ReactNode;
  readonly variant?: "full" | "compact";
}

export function Header({ right, variant = "full" }: HeaderProps): React.ReactElement {
  return (
    <header
      data-testid="chrome-header"
      data-variant={variant}
      className="bg-stage-carbon"
      style={{
        position: "sticky", top: 0, zIndex: 10,
        display: "flex", alignItems: "center", justifyContent: "space-between",
        gap: "1rem",
        padding: variant === "compact" ? "8px 16px" : "12px 24px",
        borderBottom: "1px solid var(--ledger-line)",
        backdropFilter: "blur(6px)",
      }}
    >
      <Link
        to="/"
        aria-label={headerCopy.homeLabel}
        className="font-sohne-display text-paper-cream tracking-staff"
        style={{ fontSize: variant === "compact" ? "1rem" : "1.25rem", textDecoration: "none" }}
      >
        {headerCopy.brand}
      </Link>
      <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>{right}</div>
    </header>
  );
}

export default Header;
